import { OverviewMetricLabel, OverviewMetricValue } from './styledComponents';
import { PlaceholderText } from '../Placeholders';
import SelectableCombinedMetric from './SelectableCombinedMetric';
import styled from 'styled-components';

function OverviewMetrics({
    isLoading,
    metrics,
    predictionMetrics,
    showDataSource = true,
    predictionMetricsCss,
    showDataSourceBar = true,
    customCss,
    wrapperCss,
}) {
    return (
        <Wrapper css={wrapperCss}>
            {isLoading && !(metrics || predictionMetrics) ? (
                <span>
                    <OverviewMetricValue>
                        <PlaceholderText />
                    </OverviewMetricValue>
                    <OverviewMetricLabel>
                        <PlaceholderText />
                    </OverviewMetricLabel>
                </span>
            ) : null}
            {metrics?.map(
                ({
                    metrics,
                    metricsList,
                    metricsListLabel,
                    defaultMetric,
                    week,
                    year,
                }) => {
                    const tikTokSourceAttributionProps = { week, year };
                    return (
                        <SelectableCombinedMetric
                            metricsList={metricsList}
                            metricsListLabel={metricsListLabel}
                            metrics={metrics}
                            defaultMetric={defaultMetric}
                            isLoading={isLoading}
                            tikTokSourceAttributionProps={
                                tikTokSourceAttributionProps
                            }
                            showDataSource={showDataSource}
                            key={defaultMetric?.key}
                            showDataSourceBar={showDataSourceBar}
                            customCss={customCss}
                        />
                    );
                },
            )}
            <span
                css={`
                    margin-left: auto;
                    ${predictionMetricsCss || ''}
                `}
            >
                {predictionMetrics?.map(
                    ({ metrics, metricsList, defaultMetric }) => {
                        return (
                            <SelectableCombinedMetric
                                metricsList={metricsList}
                                metrics={metrics}
                                defaultMetric={defaultMetric}
                                isLoading={isLoading}
                                key={defaultMetric?.key}
                                showDataSource={showDataSource}
                                selectable={false}
                                showDataSourceBar={showDataSourceBar}
                                customCss={customCss}
                            />
                        );
                    },
                )}
            </span>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    color: ${({ theme }) => theme.black};
    display: flex;
    gap: 1rem;
`;

export default OverviewMetrics;
